<app-breadcrumb [master]="'Rozliczenia'" [parentName]="'Przepięcia polis'" [name]="'Lista'"></app-breadcrumb>
<div class="commission-redirections-list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm">

    <app-dict-insurance-companies
      [multiple]="true" label="TU" class="commission-redirections-list-filter"
      [(ngModel)]="initialFilters.in$insuranceCompany"
      name="in$insuranceCompany"
    ></app-dict-insurance-companies>

    <app-dict
      [multiple]="false"
      label="Firma" class="commission-redirections-list-filter"
      dictType="company"
      [(ngModel)]="initialFilters.company" name="company"
    ></app-dict>

    <app-dict-ofwcas
      [multiple]="false"
      label="OFWCA zawierająca polisę" class="commission-redirections-list-filter"
      [(ngModel)]="initialFilters.ofwca"
      name="ofwca"
    ></app-dict-ofwcas>

    <mat-form-field
      class="commission-redirections-list-filter">
      <mat-label>Numer polisy</mat-label>
      <input matInput placeholder="Numer polisy" name="contains$policyNumber" [(ngModel)]="initialFilters.contains$policyNumber">
    </mat-form-field>

    <mat-form-field class="commission-redirections-list-filter">
      <mat-label>Nazwa klienta</mat-label>
      <input matInput placeholder="Nazwa klienta" name="contains$customerName" [(ngModel)]="initialFilters.contains$customerName">
    </mat-form-field>

    <app-datepicker
      class="commission-redirections-list-filter"
      label="Data zawarcia od"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.gte$concludeDate" name="gte$concludeDate"
    ></app-datepicker>

    <app-datepicker
      class="commission-redirections-list-filter"
      label="Data zawarcia do"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.lte$concludeDate" name="lte$concludeDate"
    ></app-datepicker>

    <app-dict-ofwcas
      [multiple]="false"
      label="OFWCA na którą przepinamy" class="commission-redirections-list-filter"
      [(ngModel)]="initialFilters.newOfwca"
      name="newOfwca"
    ></app-dict-ofwcas>

    <app-dict-partners
      [multiple]="false" label="Partner"
      class="commission-redirections-list-filter"
      [(ngModel)]="initialFilters.newPartner" name="newPartner"
    ></app-dict-partners>

    <app-dict-regionals
      [multiple]="true" label="Regionalny (majątek) Partnera"
      class="commission-redirections-list-filter"
      [(ngModel)]="initialFilters.newPartnerAssetsRegional" name="newPartnerAssetsRegional"
    ></app-dict-regionals>

    <mat-form-field class="commission-redirections-list-filter">
      <mat-label>Stawka % Partner od</mat-label>
      <input matInput placeholder="Stawka % Partner od" name="gte$ratePaid" [(ngModel)]="initialFilters.gte$ratePaid">
    </mat-form-field>

    <mat-form-field class="commission-redirections-list-filter">
      <mat-label>Stawka % Partner do</mat-label>
      <input matInput placeholder="Stawka % Partner do" name="lte$ratePaid" [(ngModel)]="initialFilters.lte$ratePaid">
    </mat-form-field>

    <mat-form-field class="commission-redirections-list-filter">
      <mat-label>Przypis od</mat-label>
      <input matInput placeholder="Stawka % Partner od" name="gte$assign" [(ngModel)]="initialFilters.gte$assign">
    </mat-form-field>

    <mat-form-field class="commission-redirections-list-filter">
      <mat-label>Przypis do</mat-label>
      <input matInput placeholder="Stawka % Partner do" name="lte$assign" [(ngModel)]="initialFilters.lte$assign">
    </mat-form-field>

  </form>

  <div class="commission-redirections-list-buttons">
    <button *ngIf="(userPermissions | async).commission_redirection.read_report"
      [disabled]="!(userPermissions | async).commission_redirection.read_report"
      mat-raised-button [matMenuTriggerFor]="generate"
      class="report-button"
    ><mat-icon>download</mat-icon> Pobierz raport</button>
    <mat-menu #generate="matMenu">
      <button mat-menu-item (click)="downloadReport()">Przepięć polis</button>
      <button mat-menu-item (click)="downloadCrossCompanyReport()">Przepięć polis pomiędzy firmami</button>
    </mat-menu>

    <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
    <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
  </div>

  <table mat-table [dataSource]="items">

    <ng-container matColumnDef="insuranceCompany">
      <th mat-header-cell *matHeaderCellDef> TU </th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/tu/szczegoly', element.insuranceCompany.id]">{{element.insuranceCompany.name}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="company">
      <th mat-header-cell *matHeaderCellDef> Firma </th>
      <td mat-cell *matCellDef="let element">
        {{element.company?.name}}
      </td>
    </ng-container>

    <ng-container matColumnDef="ofwca">
      <th mat-header-cell *matHeaderCellDef> OFWCA zawierająca polisę </th>
      <td mat-cell *matCellDef="let element">
        <a *ngIf="element.ofwca" class="default-link" [routerLink]="['/ofwca/szczegoly', element.ofwca.uuid]">{{element.ofwca.fullName}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="policyNumber">
      <th mat-header-cell *matHeaderCellDef> Numer polisy/Nazwa klienta </th>
      <td mat-cell *matCellDef="let element">
        <div class="expect-flex">
          <mat-chip-list *ngIf="element.expect" >
            <mat-chip class="expect" color="primary"  matTooltip="Oczekuje">O</mat-chip>
          </mat-chip-list>
          <a class="default-link extra-letter-spacing" [routerLink]="['/przepiecia-polis/szczegoly', element.uuid]">
            {{element.policyNumber ? element.policyNumber : ''}}
            <ng-container *ngIf="element.customerName !== null">
              <br *ngIf="element.policyNumber"> <span class="extra-letter-spacing">{{element.customerName}}</span>
            </ng-container>
          </a>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="ratePaid">
      <th mat-header-cell *matHeaderCellDef> Stawka % Partner </th>
      <td mat-cell *matCellDef="let element">
        <mat-chip-list *ngIf="element.ratePaid">
          <mat-chip class="green-mat-chip" selected *ngIf="(userPermissions | async).commission_redirection.delete">{{element.ratePaid}}</mat-chip>
        </mat-chip-list>
      </td>
    </ng-container>

    <ng-container matColumnDef="newOfwca">
      <th mat-header-cell *matHeaderCellDef> OFWCA na którą przepinamy </th>
      <td mat-cell *matCellDef="let element">
        <a
          *ngIf="element?.newOfwca"
          class="default-link" [routerLink]="['/ofwca/szczegoly', element.newOfwca.uuid]">{{element.newOfwca?.fullName}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="newPartner">
      <th mat-header-cell *matHeaderCellDef> Partner </th>
      <td mat-cell *matCellDef="let element">
        <a *ngIf="element?.newPartner" class="default-link"
           [routerLink]="['/partnerzy/szczegoly', element?.newPartner?.uuid]">{{element?.newPartner?.shortName}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="newPartnerAssetsRegional">
      <th mat-header-cell *matHeaderCellDef> Regionalny (majątek) Partnera/OFWCA  </th>
      <td  mat-cell *matCellDef="let element" >
       <p *ngIf="element?.newPartner"> {{element.newPartner?.assetsRegional?.fullName}}</p>
        <p *ngIf="!element?.newPartner"> {{element.newOfwca?.assetsRegional?.fullName}}</p>
      </td>
    </ng-container>

    <ng-container matColumnDef="OfwcaAssetsRegional">
      <th mat-header-cell *matHeaderCellDef> Regionalny (majątek) OFWCA Zawierająca </th>
      <td mat-cell *matCellDef="let element">
       {{element.ofwca?.assetsRegional?.fullName}}
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <button mat-icon-button [matMenuTriggerFor]="menu"><mat-icon>expand_more</mat-icon></button>
        <mat-menu #menu="matMenu" xPosition="before">
          <button [disabled]="!(userPermissions | async).commission_redirection.delete" mat-menu-item (click)="delete(element)">Usuń</button>
        </mat-menu>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
